/**
 * Defensively extract a human-readable string from an API error response
 * body, regardless of shape. Guards against `[object Object]` ever reaching
 * the UI — e.g. FastAPI's raw 422 body (`{"detail": [{...}, ...]}`, an
 * array of objects) or an unexpected nested shape, neither of which are
 * plain strings.
 */
export function extractErrorMessage(body: unknown, fallback: string): string {
  if (body && typeof body === 'object') {
    const obj = body as Record<string, any>;

    const errorMessage = obj?.error?.message;
    if (typeof errorMessage === 'string' && errorMessage.trim()) return errorMessage;

    const detail = obj?.detail;
    if (typeof detail === 'string' && detail.trim()) return detail;
    if (Array.isArray(detail) && detail.length > 0) {
      const first = detail[0];
      if (typeof first === 'string') return first;
      if (first && typeof first === 'object' && typeof first.msg === 'string') return first.msg;
    }
  }
  return fallback;
}
